/**
 * PlanningEventDependencyEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { PlanningEventEntity } from "../PlanningEventEntity";
import { ProjectEntity } from "../ProjectEntity";
import { PlanningEventGroupEntity } from "../PlanningEventGroupEntity";
import { PlanningEventDependencyEntity } from "../PlanningEventDependencyEntity";
declare global {
    interface EntityTypeMap {
        PlanningEventDependency: PlanningEventDependencyEntity;
    }
}
export abstract class PlanningEventDependencyGeneratedEntity extends BaseEntity {
    public abstract planningEventDependencyId: string;
    public abstract type: number;
    public abstract offset: number;
    public abstract offsetType: number;
    public abstract predecessorEvent: PlanningEventEntity | null;
    public abstract successorEvent: PlanningEventEntity | null;
    public abstract project: ProjectEntity;
    public abstract predecessorEventGroup: PlanningEventGroupEntity | null;
    public abstract successorEventGroup: PlanningEventGroupEntity | null;
}
